export class JobsRoutesHelper {
    public static jobsUrlPrefix = 'recruiting/jobs';
    public static facilityDetailsUrlPrefix = 'recruiting/facilities/';

    public static getJobsGridUrl(): string {
        return this.jobsUrlPrefix;
    }

    public static getFacilityDetailsUrl(id: number): string {
        return `${this.facilityDetailsUrlPrefix}${id}`;
    }

    public static getUnitLink(unitFormId: number | string, contactId: number, domain: string) {
        if (domain.indexOf('http') < 0) {
            domain = '//' + domain;
        }

        if (!domain.endsWith('/')) {
            domain = domain + '/';
        }

        return `${domain}#/units?userId=${contactId}&formId=${unitFormId}&preview=true`;
    }
}
